var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconDeactivateUserLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconDeactivateUser",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1285.316 1467.344c-119.106 82.796-341.251 202.437-636.017 188.299-238.533-11.247-423.512-105.182-542.19-188.192v-151.346c0-128.424 82.047-238.962 195.047-262.74 113.751-23.885 230.18-37.595 345.965-40.487 146.954-3.856 296.8 9.854 442.47 40.594 112.786 23.779 194.725 134.209 194.725 262.74v151.132ZM428.44 637.994v-6.962c45.95-12.425 75.298-39.31 98.327-60.625 26.777-24.635 42.95-39.523 80.546-39.523 36.846 0 52.805 14.781 79.261 39.31 31.17 28.597 73.799 67.8 153.167 67.8 57.946 0 95.756-21.315 124.247-43.915v43.915c0 147.704-120.07 267.774-267.774 267.774S428.44 785.698 428.44 637.994ZM696.213 263.11c123.605 0 226.858 84.616 257.599 198.688-13.282 9.747-24.742 20.244-35.453 30.098-26.35 24.314-42.095 38.988-78.619 38.988-37.595 0-53.769-14.888-80.546-39.524-30.848-28.49-73.263-67.586-151.882-67.586-79.368 0-121.998 39.31-153.167 67.908-8.676 8.033-16.28 14.567-23.778 20.35C440.22 373.327 555.042 263.11 696.213 263.11Zm416.443 685.609c-57.197-12.104-115.143-20.887-173.09-27.956 79.904-68.764 131.531-169.34 131.531-282.77v-107.11C1071.097 324.27 902.935 156 696.213 156S321.329 324.27 321.329 530.884v107.11c0 113.215 51.413 213.576 131.102 282.448-57.839 6.962-115.464 16.173-172.34 28.17C117.822 982.672 0 1137.232 0 1316.105v205.865l21.743 16.066c129.175 95.221 342.002 211.435 622.522 224.61 17.245.75 34.275 1.178 51.091 1.178 318.437 0 557.72-139.564 675.22-225.788l21.85-15.959v-205.865c0-178.873-117.713-333.432-279.77-367.493ZM1839.915 156l-200.269 200.269L1439.49 156l-80.198 80.085 200.27 200.269-200.27 200.269 80.198 80.085 200.156-200.27 200.269 200.27L1920 636.623l-200.269-200.269L1920 236.085 1839.915 156Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconDeactivateUserLine.glyphName = 'deactivate-user';
IconDeactivateUserLine.variant = 'Line';
IconDeactivateUserLine.displayName = 'IconDeactivateUserLine';
IconDeactivateUserLine.allowedProps = [...SVGIcon.allowedProps];
export default IconDeactivateUserLine;
export { IconDeactivateUserLine };